import MarkerCollection from '@/lib/map-control/collection/MarkerCollection';
export default class DropMarkerCollection extends MarkerCollection {
    /**
     * 도착지 마커 생성
     * @param orderData 주문 데이터
     */
    addMarker(orderData) {
        const { orderId } = orderData;
        let mkDrop = this.items[orderId];
        if (mkDrop) {
            return mkDrop;
        }
        const { pickupLatitude: startLat, pickupLongitude: startLng, dropLatitude: endLat, dropLongitude: endLng, } = orderData;
        // 도착지 신규 생성
        mkDrop = this.createMarker(this.mapControl.marker.DROP, {
            startLat,
            startLng,
            endLat,
            endLng,
            orderData,
        });
        mkDrop.addLine();
        // 이벤트 등록
        this.naver.maps.Event.addListener(mkDrop.getNaverMarker, 'click', () => {
            this.clickCallback(orderData);
        });
        this.naver.maps.Event.addListener(mkDrop.getNaverMarker, 'mouseout', () => {
            mkDrop.setLineNormal();
            this.mouseLeaveLineCallback();
        });
        this.naver.maps.Event.addListener(mkDrop.getNaverMarker, 'mouseover', () => {
            mkDrop.setLineBold();
            this.mouseEnterLineCallback(orderId);
        });
        this.naver.maps.Event.addListener(mkDrop.line, 'click', () => {
            this.clickCallback(orderData);
        });
        this.naver.maps.Event.addListener(mkDrop.line, 'mouseout', () => {
            mkDrop.setLineNormal();
            this.mouseLeaveLineCallback();
        });
        this.naver.maps.Event.addListener(mkDrop.line, 'mouseover', () => {
            mkDrop.setLineBold();
            this.mouseEnterLineCallback(orderId);
        });
        super.add(mkDrop.id, mkDrop);
        return mkDrop;
    }
    /**
     * 도착지 마커 제거
     * @param id 주문 아이디
     */
    deleteMarker(id) {
        const marker = this.getMarker(id);
        if (marker.line) {
            marker.line.setMap(null);
        }
        super.deleteMarker(id);
    }
}
